"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const comparison_operator_value_1 = require("../../comparison-operator.value");
exports.browserCondition = {
    id: 'browser',
    category: 'technology',
    value: {
        browserAndVersionValues: [
            {
                value: 'IE',
                label: 'Internet Explorer',
                versions: ['anyVersion', '11', '10', '9', '8', '7'],
            },
            {
                value: 'Chrome',
                label: 'Chrome',
                versions: [
                    'anyVersion',
                    '83',
                    '82',
                    '81',
                    '80',
                    '79',
                    '78',
                    '77',
                    '76',
                    '75',
                    '74',
                    '73',
                    '72',
                    '71',
                    '70',
                    '69',
                    '68',
                    '67',
                    '66',
                    '65',
                    '64',
                    '63',
                    '62',
                    '61',
                    '60',
                    '59',
                    '58',
                    '57',
                    '56',
                    '55',
                    '54',
                    '53',
                    '52',
                    '51',
                    '50',
                    '49',
                    '48',
                    '47',
                    '46',
                    '45',
                    '44',
                    '43',
                    '42',
                    '41',
                    '40',
                ],
            },
            {
                value: 'Firefox',
                label: 'Firefox',
                versions: [
                    'anyVersion',
                    '73',
                    '72',
                    '71',
                    '70',
                    '69',
                    '68',
                    '67',
                    '66',
                    '65',
                    '64',
                    '63',
                    '62',
                    '61',
                    '60',
                    '59',
                    '58',
                    '57',
                    '56',
                    '55',
                    '54',
                    '53',
                    '52',
                    '51',
                    '50',
                    '49',
                    '48',
                    '47',
                    '46',
                    '45',
                    '44',
                    '43',
                    '42',
                    '41',
                    '40',
                    '39',
                    '38',
                    '37',
                    '36',
                    '35',
                ],
            },
            {
                value: 'Safari',
                label: 'Safari',
                versions: ['anyVersion', '13', '12', '11', '10', '9', '8', '7'],
            },
            {
                value: 'Opera',
                label: 'Opera',
                versions: [
                    'anyVersion',
                    '67',
                    '66',
                    '65',
                    '64',
                    '63',
                    '62',
                    '61',
                    '60',
                    '59',
                    '58',
                    '57',
                    '56',
                    '55',
                    '54',
                    '53',
                    '52',
                    '51',
                    '50',
                    '49',
                    '48',
                    '47',
                    '46',
                    '45',
                    '44',
                    '43',
                    '42',
                    '41',
                    '40',
                    '39',
                    '38',
                    '37',
                    '36',
                    '35',
                    '34',
                    '33',
                    '32',
                    '31',
                    '30',
                    '29',
                    '28',
                    '27',
                ],
            },
            {
                value: 'Mobile Safari',
                label: 'Safari Mobile',
                versions: ['anyVersion', '13', '12', '11', '10', '9', '8', '7'],
            },
            {
                value: 'IEMobile',
                label: 'Internet Explorer Mobile',
                versions: ['anyVersion', '11', '10'],
            },
        ],
        operatorValues: [
            { value: comparison_operator_value_1.ComparisonOperators.MATCH_EQUALS, label: 'CONDITION_SELECT_IS' },
            { value: comparison_operator_value_1.ComparisonOperators.MATCH_NOT_EQUALS, label: 'CONDITION_SELECT_IS_NOT' },
        ],
    },
};
//# sourceMappingURL=browser-condition.value.js.map